import scorecardScroller from './ScorecardScroller'
import scorecardExport from './ScorecardExport'
import scorecardFilter from './ScorecardFilter'
import scorecardStatTesting from './ScorecardStatTesting'

const scorecardView = {
  heights: {
    marginHeight: 50,
    navbarHeight: 64,
    headerHeight: 70,
    filterHeight: 80,
    footerHeight: 65,
    legendHeight: 100
  },
  hasPresetButton: false,
  enableQuickview: true,
  collapsed: true,
  scorecardScroller,
  scorecardExport,
  scorecardStatTesting,
  scorecardFilter
}

export default scorecardView

export {
  scorecardView,
  scorecardScroller,
  scorecardFilter,
  scorecardExport
}



// WEBPACK FOOTER //
// ./src/app/configuration/TargetRetailWalmart/config/components/scorecard/ScorecardView/index.js